import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { ClientStateService } from '../../client-state/logic/client-state.service';

@Injectable({
  providedIn: 'root',
})
export class IsPassengerVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'isPassenger';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    return this.clientStateService.theState.getValue()?.isPassenger ?? false;
  }

  // Private Functions
}
